import httpService from '@/api/http';
import { LOADING_KEY } from '@/util/constants';


function venueFetchStripePrices(
  context,
  {  loadingKey = LOADING_KEY.VENUE_STRIPE_FETCH_PRICES },
) {
  return httpService.get(`venue/stripe/prices`, {
    headers: { loadingKey },
  });
}

function venueCreateCheckoutSession(
  context,
  { data, loadingKey = LOADING_KEY.VENUE_UPDATE_UNIT },
) {
  return httpService.post(`/venue/stripe/checkout-session`, data, {
    headers: {
      loadingKey,
    },
  });
}


export default {
  venueFetchStripePrices,
  venueCreateCheckoutSession
};
